export default "__VITE_ASSET__DZduSGIF__"